import React, { useState } from "react";

const styles = `
  .request-access-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #004263 0%, #42b0d5 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    font-family: "Maersk Text", Arial, sans-serif;
  }

  .request-access-card {
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 12px 32px rgba(0, 66, 99, 0.18);
    padding: clamp(1.5rem, 4vw, 2.5rem);
    max-width: 640px;
    width: 100%;
    color: #004263;
  }

  .request-access-title {
    font-size: clamp(1.5rem, 4.5vw, 2.2rem);
    font-weight: 700;
    margin: 0 0 0.75rem 0;
    text-align: center;
  }

  .request-access-message {
    font-size: 1rem;
    line-height: 1.5;
    margin-bottom: 1.25rem;
    text-align: center;
  }

  .request-access-subtitle {
    font-size: 0.95rem;
    margin-bottom: 0.5rem;
    font-weight: 600;
  }

  .request-access-textarea {
    width: 100%;
    min-height: 120px;
    border: 1px solid #c4d9e4;
    border-radius: 8px;
    padding: 0.75rem;
    resize: vertical;
    font-size: 0.95rem;
    font-family: "Maersk Text", Arial, sans-serif;
    color: #003a56;
    box-sizing: border-box;
  }

  .request-access-error {
    color: #b8382d;
    font-size: 0.85rem;
    margin-top: 0.5rem;
  }

  .request-access-actions {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
  }

  .request-access-button {
    border: none;
    border-radius: 8px;
    background: #42b0d5;
    color: #003a56;
    font-size: 0.95rem;
    font-weight: 600;
    padding: 0.75rem 1.5rem;
    cursor: pointer;
    font-family: "Maersk Text", Arial, sans-serif;
  }

  .request-access-button:hover {
    background: #36a4c8;
  }
`;

const STYLE_ID = "request-access-loader-styles-dtr";

if (
  typeof window !== "undefined" &&
  !document.head.querySelector(`style[data-style-id="${STYLE_ID}"]`)
) {
  const style = document.createElement("style");
  style.setAttribute("data-style-id", STYLE_ID);
  style.textContent = styles;
  document.head.appendChild(style);
}

const RequestAccessLoader = ({ onRequestAccess, submitError = "" }) => {
  const [justification, setJustification] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (!justification.trim()) {
      setError("Please provide a business justification before requesting access.");
      return;
    }
    setError("");
    if (onRequestAccess) onRequestAccess(justification.trim());
  };

  return (
    <div className="request-access-container">
      <div className="request-access-card">
        <h1 className="request-access-title">Sorry you do not have access</h1>
        <p className="request-access-message">
          To request access, press the button below.
        </p>
        <p className="request-access-subtitle">
          Please provide a strong business justification for why you need access:
        </p>
        <textarea
          className="request-access-textarea"
          value={justification}
          onChange={(event) => setJustification(event.target.value)}
          placeholder="Enter business justification..."
        />
        {(error || submitError) && (
          <p className="request-access-error">{error || submitError}</p>
        )}
        <div className="request-access-actions">
          <button className="request-access-button" onClick={handleSubmit}>
            Request Access
          </button>
        </div>
      </div>
    </div>
  );
};

export default RequestAccessLoader;
